import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../../environments/environment';
import {UnitModel} from '../../../unit/unit.model';
import {ExecutorPricePlanGroupModel} from '../../../executor-price-plan/executor-price-plan-group-list/executor-price-plan-group.model';

@Injectable({
  providedIn: 'root'
})
export class ExecutorPricePlanGroupListService {

  constructor(
    private http: HttpClient
  ) { }

  public getPricePlanGroups(projectId: number) {
    let url = environment.apiBasepoint + 'executor-price-plan-group?fields=id,name';
    if (projectId) {
      url = url + '&ExecutorPricePlanGroupSearch%5Bproject_id%5D=' + projectId.toString(10);
    }
    return this.http.get<ExecutorPricePlanGroupModel[]>(
      url,
      {observe: 'body'}
    );
  }
}
